import { render } from "./CouponSavePage.vue?vue&type=template&id=cc73bcaa"
import script from "./CouponSavePage.vue?vue&type=script&lang=js"
export * from "./CouponSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script